import { useSpring, animated } from '@react-spring/web'
import cn from 'clsx'
import * as React from 'react'

import { config, type IconProps } from '#app/components/icon'

const TransportFree: React.FC<IconProps> = (props) => {
	const { animate = false, className, width, height } = props

	const [style, api] = useSpring(() => ({
		from: {
			x: 0,
			opacity: 1,
		},
		config: {
			duration: 800,
		},
	}))

	React.useEffect(() => {
		if (animate) {
			Promise.all(
				api.start({
					to: [
						{
							x: 150,
							opacity: 0,
						},
						{
							x: -150,
							opacity: 0,
						},
						{
							x: 0,
							opacity: 1,
						},
					],
				}),
			).catch(console.error)
		}
	}, [animate, api])

	return (
		<animated.span style={style}>
			<svg
				id="Ebene_1"
				data-name="Ebene 1"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 425.2 425.2"
				className={className}
				width={width || config.width}
				height={height || config.height}
			>
				<path // ???
					d="m372,219.28s-.02-.01-.02-.03c-.13-.98-.61-1.93-1.4-2.67l-32.03-29.9c-.88-.83-2.02-1.25-3.16-1.25-.07,0-.15,0-.22.02-.08-.02-.16-.02-.24-.02h-30.45v-21c0-5.7-4.6-10.3-10.3-10.3h-151.42c-5.68,0-10.3,4.6-10.3,10.3v7.83H63c-4.31,0-7.81,3.49-7.81,7.8v3.89c0,4.31,3.5,7.81,7.81,7.81h69.46v9.71h-49.95c-4.31,0-7.81,3.5-7.81,7.81v3.88c0,4.32,3.5,7.81,7.81,7.81h49.95v9.71H63c-4.31,0-7.81,3.5-7.81,7.81v3.89c0,4.31,3.5,7.81,7.81,7.81h69.46v14.99c0,5.7,4.62,10.31,10.3,10.31h13.96c0-16.24,13.16-29.39,29.39-29.39s29.39,13.15,29.39,29.39h78.68c2.95,0,5.62-1.24,7.49-3.24,0,0,.03-.02.07-.07.02-.03.05-.05.06-.08.32-.46,1.29-1.84,1.71-3.38,0-.01.01-.03.01-.04l.96-3.54v-.02c.14-.37.29-.75.45-1.12.14-.31.28-.63.42-.93,4.68-10.02,14.84-16.97,26.63-16.97s22.1,7.03,26.73,17.17l.24.52c1.56,3.58,2.42,7.54,2.42,11.7,0,.35,0,.7-.03,1.03h6.21c2.56,0,4.63-2.07,4.63-4.62v-51.34c0-.43-.06-.88-.18-1.28Zm-63,2.61v-26.19h22.63l27.03,25.03,1.24,1.15h-50.91Z"
				/>
				<path // ???
					d="m205.63,276.06c0,11.01-8.93,19.94-19.95,19.94s-19.94-8.93-19.94-19.94,8.93-19.94,19.94-19.94,19.95,8.93,19.95,19.94Z"
					className={cn('transition-all duration-500 ease-in-out', {
						'fill-accent-10': animate,
					})}
				/>
				<path // ???
					d="m352.16,276.06c0,11.01-8.93,19.94-19.95,19.94s-19.94-8.93-19.94-19.94,8.93-19.94,19.94-19.94,19.95,8.93,19.95,19.94Z"
					className={cn('transition-all duration-500 ease-in-out', {
						'fill-accent-10': animate,
					})}
				/>
				<text // ???
					transform="translate(153.74 224.44)"
					fontSize="4rem"
					fontWeight="100"
				>
					<tspan // ???
						x="0"
						y="0"
					>
						FREE
					</tspan>
				</text>
			</svg>
		</animated.span>
	)
}

export { TransportFree }
